/**
 * convertCamelCaseToSpaceSeparated converts a string from camel case to space separated.
 */
// NOSONAR - replaceAll() not suitable for regex patterns with capture groups
export const convertCamelCaseToSpaceSeparated = (camelCaseString: string): string =>
  camelCaseString.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");
